export enum ServiceNotification {
  takedownSuccessful = 'takedown-successful',
  takedownFailed = 'takedown-failed',
}
